import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { useContext, useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  error,
  success,
} from "../../../../../components/alertMessagesHandler/alert";
import CButton from "../../../../../components/buttons/Button";
import CDropdownSingleSelect from "../../../../../components/dropdown/dropdownSingleSelect";
import CEmailField from "../../../../../components/inputBoxes/email-input";
import COnlyNumberField from "../../../../../components/inputBoxes/number-input";
import CTextField from "../../../../../components/inputBoxes/text-input";
import CUrlField from "../../../../../components/inputBoxes/url-input";
import { LoadingContext } from "../../../../../context/loadingContext";
import {
  AddNewBusinessBasicDataHooks,
  AddNewBusinessBasicDataUpdateHooks,
  SignUpBasicDataBusinessHooks,
  SignUpBasicDataHooks,
} from "../../hooks/useSignup";

const RegBasicData = (props) => {
  const { setLoading } = useContext(LoadingContext);
  const dispatch = useDispatch();
  const BasicReducer = useSelector((state) => state.BusinessBasicReducer);
  const [FieldValues, setFieldValues] = useState();
  const [addNewBusinessBasicData, SetAddNewBusinessBasicData] = useState();
  const { portal_id } = useParams();

  useEffect(() => {
    getAutoField();
    // setButtonAutoPopulate();
  }, [props]);

  // Autofill existing profile field using AddNewBusinessBasicDataHooks

  const getAutoField = async () => {
    const autoField = await AddNewBusinessBasicDataHooks();
    SetAddNewBusinessBasicData(autoField.data);
  };

  // const setButtonAutoPopulate = () => {
  //   switch (
  //     props.AutoFillDataProp.data_portal_infos &&
  //     props.AutoFillDataProp.data_portal_infos[0].data_pub_basics[0]
  //       ? props.AutoFillDataProp.data_portal_infos[0].data_pub_basics[0][
  //           "above_50k"
  //         ]
  //       : ""
  //   ) {
  //     case 1:
  //       document.getElementById("yes50k").checked = true;
  //       break;

  //     case 0:
  //       document.getElementById("no50k").checked = true;
  //       break;
  //   }

  //   switch (
  //     props.AutoFillDataProp.data_portal_infos &&
  //     props.AutoFillDataProp.data_portal_infos[0].data_pub_basics[0]
  //       ? props.AutoFillDataProp.data_portal_infos[0].data_pub_basics[0][
  //           "blog_platform"
  //         ]
  //       : ""
  //   ) {
  //     case "Wordpress":
  //       document.getElementById("wp").checked = true;
  //       break;

  //     case "Blogger":
  //       document.getElementById("blog").checked = true;
  //       break;

  //     case "Other":
  //       document.getElementById("other").checked = true;
  //       break;
  //   }
  // };

  // Update portal and basic data using AddNewBusinessBasicDataUpdateHooks

  const basicDataUpdate = async () => {
    setLoading(true);
    const data = {
      mpi_id: Number(portal_id),
      updateData: FieldValues,
    };
    const result = await AddNewBusinessBasicDataUpdateHooks(data);
    setLoading(false);
    if (result.status === 200) {
      document.getElementById("pills-theme-tab").click();

      success("Basic Data Updated successfully");
    } else {
      error(result.message);
    }
  };

  // Basic data register in registration page using SignUpBasicDataHooks and add new business in dashboard using SignUpBasicDataBusinessHooks

  const basicDataHandle = async () => {
    setLoading(true);
    const res =
      props.regPage === "registration"
        ? await SignUpBasicDataHooks(FieldValues)
        : await SignUpBasicDataBusinessHooks(FieldValues);
    setLoading(false);
    if (res.status === 200) {
      dispatch({ type: "BUSINESS_BASIC_DONE" });
      document.getElementById("pills-theme-tab").click();
      success("Basic Data created successfully");
    } else {
      error(res.message);
    }
  };

  const HandleFieldsValue = (key, value) => {
    setFieldValues({ ...FieldValues, [key]: value });
  };

  const submit = (event) => {
    event.preventDefault();
    if (props.regPage === "update-new-business") {
      basicDataUpdate();
    } else {
      if (BasicReducer === 0) {
        basicDataHandle();
      } else document.getElementById("pills-theme-tab").click();
    }
  };

  return (
    <>
      <div className="container">
        <form onSubmit={submit}>
          <div className="row">
            <div className="col-3"></div>
            <div className="col-md-3 col-sm-12">
              <CTextField
                required={true}
                labelName={"First Name"}
                name={"firstname"}
                readOnly={
                  props.regPage === "registration"
                    ? false
                    : addNewBusinessBasicData
                      ? true
                      : false
                }
                value={
                  addNewBusinessBasicData
                    ? addNewBusinessBasicData.firstname
                    : props.AutoFillDataProp
                      ? props.AutoFillDataProp.firstname
                      : ""
                }
                customClassDiv={"mb-4 text-dark"}
                customClassInput={"bg-primary-soft"}
                functionName={(name, first_name) =>
                  props.regPage === "registration"
                    ? HandleFieldsValue(name, first_name)
                    : ""
                }
              />
            </div>
            <div className="col-md-3 col-sm-12">
              <CTextField
                required={true}
                labelName={"Last Name"}
                name={"lastname"}
                readOnly={
                  props.regPage === "registration"
                    ? false
                    : addNewBusinessBasicData
                      ? true
                      : false
                }
                value={
                  addNewBusinessBasicData
                    ? addNewBusinessBasicData.lastname
                    : props.AutoFillDataProp
                      ? props.AutoFillDataProp.lastname
                      : ""
                }
                customClassDiv={"mb-4 text-dark"}
                customClassInput={"bg-primary-soft"}
                functionName={(name, last_name) =>
                  props.regPage === "registration"
                    ? HandleFieldsValue(name, last_name)
                    : ""
                }
              />
            </div>
            <div className="col-3"></div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12"></div>
            <div className="col-md-5 col-sm-12">
              <CEmailField
                required={true}
                customClassDiv={"mb-4 text-dark"}
                customClassInput={"bg-primary-soft"}
                labelName={"Email"}
                name={"email"}
                readOnly={true}
                value={
                  addNewBusinessBasicData
                    ? addNewBusinessBasicData.email
                    : props.AutoFillDataProp
                      ? props.AutoFillDataProp.email
                      : ""
                }
              />
              <div className="mb-4 text-dark">
                <label className="mb-2">Phone</label>
                <PhoneInput
                  inputProps={{
                    name: "mobile",
                    required: true,
                    autoFocus: true,
                  }}
                  value={
                    addNewBusinessBasicData
                      ? addNewBusinessBasicData.mobile
                      : props.AutoFillDataProp
                        ? props.AutoFillDataProp.mobile
                        : ""
                  }
                  disabled={props.regPage === "registration" ? false : true}
                  country={"kr"}
                  onChange={(phone) => HandleFieldsValue("mobile", phone)}
                />
              </div>
              <CTextField
                required={true}
                placeholder={"mydomain"}
                labelName={"Domain Name"}
                spanInput={"( domain name without https, www and .xyz )"}
                customClassSpanInput={"text-muted"}
                name={"portal_name"}
                value={
                  props.AutoFillDataProp.data_portal_infos
                    ? props.AutoFillDataProp.data_portal_infos[0].portal_name
                    : ""
                }
                customClassDiv={"mb-4 text-dark"}
                customClassInput={"bg-primary-soft"}
                functionName={(name, domain_name) =>
                  HandleFieldsValue(name, domain_name)
                }
              />
              <CUrlField
                required={true}
                labelName={"Domain URL"}
                placeholder={"mydomain.xyz"}
                name={"portal_url"}
                customClassDiv={"text-dark mb-3"}
                customClassInput={"bg-primary-soft"}
                readOnly={props.regPage === "registration" ? true : false}
                value={
                  props.regPage === "registration"
                    ? Cookies.get("portal_name")
                    : props.AutoFillDataProp.data_portal_infos
                      ? props.AutoFillDataProp.data_portal_infos[0].portal_url
                      : ""
                }
                functionName={
                  props.regPage === "registration"
                    ? ""
                    : (name, domain_url) => HandleFieldsValue(name, domain_url)
                }
              />
              {props.regPage !== "registration" ? (
                <small className="text-danger">
                  Please use your plain URL. No http, https, or www. We do not
                  accept sites on <a href="#">blogpost.com</a>, Instagram URL's
                  or social media pages.
                </small>
              ) : (
                ""
              )}
              {/* <div className="row mt-2 mb-4">
                <div className="col-md-4 col-sm-12">
                  <p className="text-dark mt-4">Domain Authority</p>
                </div>
                <div className="col-md-8 col-sm-12">
                  <COnlyNumberField
                    required={true}
                    pattern={"[0-9]?[0-9]"}
                    customClassDiv={"text-dark col-md-9 col-sm-12 w-50"}
                    value={
                      props.AutoFillDataProp.data_portal_infos &&
                      props.AutoFillDataProp.data_portal_infos[0]
                        .data_pub_basics[0]
                        ? props.AutoFillDataProp.data_portal_infos[0]
                            .data_pub_basics[0]["domain_authority"]
                        : ""
                    }
                    customClassInput={"bg-primary-soft form-control-sm w-50"}
                    name={"domain_authority"}
                    functionName={(name, num) => HandleFieldsValue(name, num)}
                  />
                </div>
              </div> */}
              <div className="row mb-4">
                <div className="col-md-6 col-sm-12">
                  <CDropdownSingleSelect
                    required={true}
                    labelName={"Language"}
                    name={"languages"}
                    placeholder={"Language"}
                    customClassDiv={"text-dark mt-3"}
                    customClassSelect={"bg-primary-soft text-muted"}
                    defaultValue={
                      props.AutoFillDataProp.data_portal_infos &&
                        props.AutoFillDataProp.data_portal_infos[0]
                          .data_pub_basics[0]
                        ? props.AutoFillDataProp.data_portal_infos[0]
                          .data_pub_basics[0]["languages"]
                        : ""
                    }
                    choiceListArray={[
                      { id: "eng", value: "English", label: "English" },
                      { id: "spain", value: "Spanish", label: "Spanish" },
                      { id: "italy", value: "Italian", label: "Italian" },
                    ]}
                    functionName={(name, language) =>
                      HandleFieldsValue(name, language)
                    }
                  />
                </div>
                <div className="col-md-6 col-sm-12">
                  <CDropdownSingleSelect
                    required={true}
                    labelName={"Target Country"}
                    name={"target_country"}
                    placeholder={"Country"}
                    customClassDiv={"text-dark mt-3"}
                    customClassSelect={"bg-primary-soft text-muted"}
                    defaultValue={
                      props.AutoFillDataProp.data_portal_infos &&
                        props.AutoFillDataProp.data_portal_infos[0]
                          .data_pub_basics[0]
                        ? props.AutoFillDataProp.data_portal_infos[0]
                          .data_pub_basics[0]["target_country"]
                        : ""
                    }
                    choiceListArray={[
                      { id: "us", value: "us", label: "US" },
                      { id: "uk", value: "uk", label: "UK" },
                    ]}
                    functionName={(name, country) =>
                      HandleFieldsValue(name, country)
                    }
                  />
                </div>
              </div>
              <CDropdownSingleSelect
                required={true}
                labelName={"Publishing Speed"}
                faIcon={faInfoCircle}
                faClass={"ms-2 text-primary"}
                faTitle={
                  "How much time do you take to publish approved guest posts? If you are unsure, mention upto 2 weeks."
                }
                name={"publishing_speed"}
                placeholder={"Speed"}
                customClassDiv={"text-dark mb-4"}
                customClassSelect={"bg-primary-soft text-muted"}
                defaultValue={
                  props.AutoFillDataProp.data_portal_infos &&
                    props.AutoFillDataProp.data_portal_infos[0].data_pub_basics[0]
                    ? props.AutoFillDataProp.data_portal_infos[0]
                      .data_pub_basics[0]["publishing_speed"]
                    : ""
                }
                choiceListArray={[
                  { id: "1-3 Days", value: "1-3 Days", label: "1-3 Days" },
                  { id: "3-7 Days", value: "3-7 Days", label: "3-7 Days" },
                  { id: "7-14 Days", value: "7-14 Days", label: "7-14 Days" },
                ]}
                functionName={(name, speed) => HandleFieldsValue(name, speed)}
              />
              <COnlyNumberField
                required={true}
                labelName={"Monthly Traffic"}
                name={"monthly_traffic"}
                pattern={"[0-9]+?"}
                customClassDiv={"text-dark mb-4"}
                customClassInput={"bg-primary-soft"}
                value={
                  props.AutoFillDataProp.data_portal_infos &&
                    props.AutoFillDataProp.data_portal_infos[0].data_pub_basics[0]
                    ? props.AutoFillDataProp.data_portal_infos[0]
                      .data_pub_basics[0]["monthly_traffic"]
                    : ""
                }
                functionName={(name, monthly_traffic) =>
                  HandleFieldsValue(name, monthly_traffic)
                }
              />
            </div>
            <div className="col-md-4 col-sm-12"></div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12"></div>
            <div className="col-md-6 col-sm-12 mb-4 text-dark">
              <div className="mb-4">
                {/* <p className="m-0">
                  According to Google Analytics, how many sessions have you had
                  the last 30 days?*
                </p>
                <p className="mb-2">
                  We cannot currently accept GA4 reports, you must be running
                  the legacy Google analytics in order for your application to
                  be processed. Mediavine requires at least 50,000
                  sessions/month to get you approved with all of our ad
                  partners.
                </p>
                <CTextField
                  labelName={
                    "PLEASE NOTE WE'RE ASKING FOR SESSIONS, NOT PAGEVIEWS."
                  }
                  name={"session"}
                  customClassDiv={"text-dark mb-4"}
                  customClassInput={"bg-primary-soft"}
                  customClassLabel={"fw-bold mb-3"}
                  functionName={(name, sessions) =>
                    HandleFieldsValue(name, sessions)
                  }
                /> */}

                {/* <CRadiobutton
                  required={true}
                  labelName={
                    "I have at least 50K sessions in the last 30 days."
                  }
                  name={"above_50k"}
                  faIcon={faInfoCircle}
                  faClass={"ms-2 text-primary"}
                  faTitle={
                    " Learn how to check through your google analytics dashboard."
                  }
                  customClassDiv={"mb-4 text-dark"}
                  isInline={true}
                  choiceListArray={[
                    { id: "yes50k", value: 1, label: "Yes" },
                    { id: "no50k", value: 0, label: "No" },
                  ]}
                  customClassLabel={"mb-3"}
                  functionName={(name, Sessions50K) =>
                    HandleFieldsValue(name, Sessions50K)
                  }
                /> */}
                {/* <CRadiobutton
                  required={true}
                  labelName={"What CMS (blog platform) are you running?"}
                  name={"blog_platform"}
                  customClassDiv={"mb-4 text-dark"}
                  isInline={true}
                  choiceListArray={[
                    { id: "wp", value: "Wordpress", label: "Wordpress" },
                    { id: "blog", value: "Blogger", label: "Blogger" },
                    { id: "other", value: "Other", label: "Other" },
                  ]}
                  customClassLabel={"mb-3"}
                  functionName={(name, CMS) => HandleFieldsValue(name, CMS)}
                /> */}
                <CButton
                  btnClassesDiv={"text-center"}
                  btnClasses={"btn px-4 fw-bold text-white"}
                  IsOutline={false}
                  innertext={"Next"}
                  btnCustomStyle={{
                    backgroundColor: "#044389",
                  }}
                />
              </div>
            </div>
            <div className="col-md-3 col-sm-12"></div>
          </div>
        </form>
      </div>
    </>
  );
};

export default RegBasicData;
